import { CertificatesConfigTypes } from "./types/certificates-config-types";

export const CertificatesConfig: CertificatesConfigTypes = {
  xxxFeatureToggle: {
    value: "Y",
  },
};
